import {get, post, del, put} from '@/api';
import * as PRESCRIPTION from '../constants/prescription';
import queryString from 'query-string';

export default {
  [PRESCRIPTION.ACTION_LIST_PRESCRIPTIONS]: ({commit}, param) => {
    const qs = queryString.stringify(param, {arrayFormat: 'bracket'});
    const promiseResult = get(`/prescription?${qs}`);

    promiseResult.then((res) => {
      commit(PRESCRIPTION.MUTATE_LIST_PRESCRIPTION, res.data);
    });

    return promiseResult;
  },

  [PRESCRIPTION.ACTION_ADD]: ({commit}, payload) => {
    return post('/prescription', payload);
  },

  [PRESCRIPTION.ACTION_DELETE]: ({commit}, payload) => {
    return del(`/prescription/${payload.id}`);
  },

  [PRESCRIPTION.ACTION_UPDATE]: ({commit}, payload) => {
    return put(`/prescription/${payload.id}`, payload);
  }
}



// WEBPACK FOOTER //
// ./src/store/prescription/actions.js